var TEMPLATE_URL = require('./premium.tile.html');

angular.module('ikeweb.user').directive('premiumTile', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            scope: {
                currentCard: '=',
                subscription: '=',
                openPurchasePremiumModal: '&',
                openPurchaseTrialModal: '&',
                cancelSubscription: '=',
                openUpdateCard: '&'
            },
            link: function($scope, $element) {

                var ccView = $element.find('.Subscription-creditCardView');
                var cancelDialog = $element.find('.Subscription-cancelConfirmDialog');

                function closeCreditCardView() {
                    ccView.addClass('Subscription-creditCardView--closed')
                        .removeClass('Subscription-creditCardView--open');
                }

                function closeCancelDialog() {
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--closed')
                        .removeClass('Subscription-cancelConfirmDialog--open');
                }

                $scope.toggleCreditCardView = function() {
                    closeCancelDialog();
                    ccView.toggleClass('Subscription-creditCardView--closed')
                        .toggleClass('Subscription-creditCardView--open');
                };

                $scope.openCancelDialog = function() {
                    closeCreditCardView();
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--open')
                        .removeClass('Subscription-cancelConfirmDialog--closed');
                };

                $scope.closeCancelDialog = closeCancelDialog;
            },
            controller: 'PremiumTileController'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/premium.tile.directive.js
// module id = 493
// module chunks = 0